import React from "react";
import {Carousel, Container, Row, Col} from 'react-bootstrap'
import CountUp from 'react-countup';
import Media from 'react-media';

import "./Swiper.css";

class Swiper extends React.Component {
  constructor(props) {
    super(props);
    this.video1 = React.createRef();
    this.video2 = React.createRef();
  }

  componentDidMount() {
    const v1 = this.video1.current;
    v1.play();
  }

  render() {
    return (
      <div className="car">
        {/* 轮播图 */}
        <Carousel
        controls={false}
        pause={false}

        // 轮播图切换时播放视频
        onSlid={
          () => {
          const v1 = this.video1.current;
          v1.play();
          const v2 = this.video2.current;
          v2.play();
          }
        }
        onSlide = {
          () => {
            const v2 = this.video2.current;
            v2.play();
            const v1 = this.video1.current;
            v1.play();
          }
        }
        >
          <Carousel.Item interval={6000}>
            <video ref={this.video1} id="video" autoPlay="autoplay" width="100%" muted>
              <source src="https://hzby-devops.oss-cn-shanghai.aliyuncs.com/hzby_website/index_banner-01.webm" type="video/webm" />
            </video>
          </Carousel.Item>
          <Carousel.Item interval={6000}>
            <video ref={this.video2} width="100%" muted>
              <source src="https://hzby-devops.oss-cn-shanghai.aliyuncs.com/hzby_website/index_banner-02.webm" type="video/webm" />
            </video>
          </Carousel.Item>
        </Carousel>
        <div className="achievement">
          <Media query="(max-width: 900px)" render={() =>
            (
              <Container fluid>
                <Row>
                  {/* <Col sm={2}></Col> */}
                  <Col xs sm >
                    <div className="element">
                      <span className="number"><CountUp duration={1} end={14} /></span>
                      <span className="plus">+</span>
                      <span className="word">客户选择</span>
                    </div>
                  </Col>
                  <Col xs sm>
                    <div className="element">
                      <span className="number"><CountUp duration={1} end={7} /></span>
                      <span className="plus">+</span>
                      <span className="word">覆盖城市</span>
                    </div>
                  </Col>
                  <Col xs sm>
                    <div className="element">
                      <span className="number"><CountUp duration={3} end={24} /></span>
                      <span className="plus">+</span>
                      <span className="word">成功案例</span>
                    </div>
                  </Col>
                  {/* <Col sm={2}></Col> */}
                </Row>
              </Container>
            )}
          />
          <Media query="(min-width: 900px)" render={() =>
            (
              <Container fluid>
                <Row>
                  <Col sm={2}></Col>
                  <Col xs sm={2} >
                    <div className="element">
                      <span className="number"><CountUp duration={1} end={14} /></span>
                      <span className="plus">+</span>
                      <span className="word">客户选择</span>
                    </div>
                  </Col>
                  <Col xs sm={2}>
                    <div className="element">
                      <span className="number"><CountUp duration={1} end={7} /></span>
                      <span className="plus">+</span>
                      <span className="word">覆盖城市</span>
                    </div>
                  </Col>
                  <Col xs sm={2}>
                    <div className="element">
                      <span className="number"><CountUp duration={3} end={24} /></span>
                      <span className="plus">+</span>
                      <span className="word">成功案例</span>
                    </div>
                  </Col>
                  <Col xs sm={2}>
                    <div className="element">
                      <span className="number"><CountUp duration={3} end={20000} /></span>
                      <span className="plus">+</span>
                      <span className="word">节能量</span>
                    </div>
                  </Col>
                  <Col sm={2}></Col>
                </Row>
              </Container>
            )}
          />
        </div>
      </div>
    )
  }
}

export default Swiper
